import { render, staticRenderFns } from "./Rente.vue?vue&type=template&id=f0b587a6&scoped=true"
import script from "./Rente.vue?vue&type=script&lang=js"
export * from "./Rente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b587a6",
  null
  
)

export default component.exports